function bracket(value) {
    return `[${value}]`;
}
export function formatArbitraryUtilityClassSuffix(value) {
    return bracket(value.replace(/\s+/g, '_'));
}
export function formatSpacingUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'numeric') {
        return classifiedValue.normalizedValue.startsWith('-')
            ? bracket(classifiedValue.normalizedValue)
            : classifiedValue.normalizedValue;
    }
    if (classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
export function formatDimensionUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'numeric'
        || classifiedValue.kind === 'token'
        || classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
export function formatBorderUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'token' || classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
export function formatBorderWidthUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'numeric') {
        return bracket(`${classifiedValue.normalizedValue}px`);
    }
    if (classifiedValue.kind === 'token' || classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
export function formatBorderStyleUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'token' || classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
export function formatRadiusUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'numeric') {
        return bracket(`${classifiedValue.normalizedValue}px`);
    }
    if (classifiedValue.kind === 'token' || classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
export function formatShadowUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'token' || classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
export function formatZIndexUtilityClassSuffix(classifiedValue) {
    if (!classifiedValue.valid) {
        return undefined;
    }
    if (classifiedValue.kind === 'numeric') {
        return classifiedValue.normalizedValue.startsWith('-')
            ? bracket(classifiedValue.normalizedValue)
            : classifiedValue.normalizedValue;
    }
    if (classifiedValue.kind === 'token' || classifiedValue.kind === 'keyword') {
        return classifiedValue.normalizedValue;
    }
    return formatArbitraryUtilityClassSuffix(classifiedValue.normalizedValue);
}
//# sourceMappingURL=utility-class-suffix.js.map